import {
  faAddressCard,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowAltCircleDown,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTrendDown,
  faArrowTrendUp,
  faArrowUp,
  faArrowsAlt,
  faArrowsAltH,
  faArrowsAltV,
  faAsterisk,
  faAt,
  faAward,
  faBan,
  faBell,
  faBold,
  faBolt,
  faBook,
  faBookmark,
  faBookOpen,
  faBriefcase,
  faBullhorn,
  faCalendarCheck,
  faCertificate,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChevronCircleUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleArrowRight,
  faClipboardCheck,
  faClipboardList,
  faClock,
  faCloudUploadAlt,
  faCode,
  faCog,
  faCogs,
  faComment,
  faComments,
  faCommentAlt,
  faCompress,
  faCopy,
  faCrop,
  faDatabase,
  faDesktop,
  faDoorClosed,
  faDoorOpen,
  faDownload,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faEquals,
  faEraser,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExpandAlt,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileCsv,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImage,
  faFileImport,
  faFileLines,
  faFilePdf,
  faFileUpload,
  faFileVideo,
  faFilter,
  faFlag,
  faGlasses,
  faGlobeAmericas,
  faGripVertical,
  faHashtag,
  faHistory,
  faHome,
  faHourglassStart,
  faIdCardAlt,
  faIndent,
  faInfo,
  faInfoCircle,
  faItalic,
  faKey,
  faKeyboard,
  faLandmark,
  faLanguage,
  faLevelDownAlt,
  faLightbulb,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faListUl,
  faLock,
  faLongArrowAltDown,
  faLongArrowAltLeft,
  faLongArrowAltUp,
  faMapMarkerAlt,
  faMedal,
  faMinus,
  faMobileAlt,
  faOutdent,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faPen,
  faPencilAlt,
  faPeopleArrows,
  faPhone,
  faPlay,
  faPlayCircle,
  faPlus,
  faPrint,
  faQrcode,
  faQuestion,
  faQuestionCircle,
  faRedoAlt,
  faRocket,
  faRulerCombined,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faShare,
  faShareAlt,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSortAlphaDown,
  faSortAmountDown,
  faSortNumericDown,
  faStar,
  faStarHalfAlt,
  faStore,
  faStream,
  faSyncAlt,
  faTable,
  faTag,
  faTasks,
  faTh,
  faThList,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTools,
  faTrashAlt,
  faTrophy,
  faTv,
  faUnderline,
  faUnlock,
  faUpDown,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserClock,
  faUserCog,
  faUserEdit,
  faUserFriends,
  faUserLock,
  faUserMinus,
  faUserPlus,
  faUserShield,
  faUsers,
  faUserSlash,
  faWandMagicSparkles,
  faWrench
} from '@fortawesome/free-solid-svg-icons';

const solidIcons = {
  'address-card': faAddressCard,
  'angle-double-left': faAngleDoubleLeft,
  'angle-double-right': faAngleDoubleRight,
  'angle-down': faAngleDown,
  'angle-left': faAngleLeft,
  'angle-right': faAngleRight,
  'angle-up': faAngleUp,
  archive: faArchive,
  'arrow-alt-circle-down': faArrowAltCircleDown,
  'arrow-circle-right': faArrowCircleRight,
  'arrow-down': faArrowDown,
  'arrow-left': faArrowLeft,
  'arrow-right': faArrowRight,
  'arrow-trend-down': faArrowTrendDown,
  'arrow-trend-up': faArrowTrendUp,
  'arrow-up': faArrowUp,
  'arrows-alt': faArrowsAlt,
  'arrows-alt-h': faArrowsAltH,
  'arrows-alt-v': faArrowsAltV,
  asterisk: faAsterisk,
  at: faAt,
  award: faAward,
  ban: faBan,
  bell: faBell,
  bold: faBold,
  bolt: faBolt,
  book: faBook,
  bookmark: faBookmark,
  'book-open': faBookOpen,
  briefcase: faBriefcase,
  bullhorn: faBullhorn,
  'calendar-check': faCalendarCheck,
  certificate: faCertificate,
  'chart-bar': faChartBar,
  'chart-line': faChartLine,
  check: faCheck,
  'check-circle': faCheckCircle,
  'check-double': faCheckDouble,
  'check-square': faCheckSquare,
  'chevron-circle-up': faChevronCircleUp,
  'chevron-down': faChevronDown,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'chevron-up': faChevronUp,
  circle: faCircle,
  'circle-arrow-right': faCircleArrowRight,
  'clipboard-check': faClipboardCheck,
  'clipboard-list': faClipboardList,
  clock: faClock,
  'cloud-upload-alt': faCloudUploadAlt,
  code: faCode,
  cog: faCog,
  cogs: faCogs,
  comment: faComment,
  comments: faComments,
  'comment-alt': faCommentAlt,
  compress: faCompress,
  copy: faCopy,
  crop: faCrop,
  database: faDatabase,
  desktop: faDesktop,
  'door-closed': faDoorClosed,
  'door-open': faDoorOpen,
  download: faDownload,
  edit: faEdit,
  'ellipsis-h': faEllipsisH,
  envelope: faEnvelope,
  equals: faEquals,
  eraser: faEraser,
  'exchange-alt': faExchangeAlt,
  exclamation: faExclamation,
  'exclamation-circle': faExclamationCircle,
  'exclamation-triangle': faExclamationTriangle,
  expand: faExpand,
  'expand-alt': faExpandAlt,
  'external-link-alt': faExternalLinkAlt,
  eye: faEye,
  'eye-slash': faEyeSlash,
  file: faFile,
  'file-alt': faFileAlt,
  'file-archive': faFileArchive,
  'file-audio': faFileAudio,
  'file-csv': faFileCsv,
  'file-download': faFileDownload,
  'file-excel': faFileExcel,
  'file-export': faFileExport,
  'file-image': faFileImage,
  'file-import': faFileImport,
  'file-lines': faFileLines,
  'file-pdf': faFilePdf,
  'file-upload': faFileUpload,
  'file-video': faFileVideo,
  filter: faFilter,
  flag: faFlag,
  glasses: faGlasses,
  'globe-americas': faGlobeAmericas,
  'grip-vertical': faGripVertical,
  hashtag: faHashtag,
  history: faHistory,
  home: faHome,
  'hourglass-start': faHourglassStart,
  'id-card-alt': faIdCardAlt,
  indent: faIndent,
  info: faInfo,
  'info-circle': faInfoCircle,
  italic: faItalic,
  key: faKey,
  keyboard: faKeyboard,
  landmark: faLandmark,
  language: faLanguage,
  'level-down-alt': faLevelDownAlt,
  lightbulb: faLightbulb,
  link: faLink,
  list: faList,
  'list-alt': faListAlt,
  'list-ol': faListOl,
  'list-ul': faListUl,
  lock: faLock,
  'long-arrow-alt-down': faLongArrowAltDown,
  'long-arrow-alt-left': faLongArrowAltLeft,
  'long-arrow-alt-up': faLongArrowAltUp,
  'map-marker-alt': faMapMarkerAlt,
  medal: faMedal,
  minus: faMinus,
  'mobile-alt': faMobileAlt,
  outdent: faOutdent,
  palette: faPalette,
  paperclip: faPaperclip,
  'paper-plane': faPaperPlane,
  pen: faPen,
  'pencil-alt': faPencilAlt,
  'people-arrows': faPeopleArrows,
  phone: faPhone,
  play: faPlay,
  'play-circle': faPlayCircle,
  plus: faPlus,
  print: faPrint,
  qrcode: faQrcode,
  question: faQuestion,
  'question-circle': faQuestionCircle,
  'redo-alt': faRedoAlt,
  rocket: faRocket,
  'ruler-combined': faRulerCombined,
  search: faSearch,
  'search-minus': faSearchMinus,
  'search-plus': faSearchPlus,
  share: faShare,
  'share-alt': faShareAlt,
  signature: faSignature,
  'sign-in-alt': faSignInAlt,
  'sign-out-alt': faSignOutAlt,
  sitemap: faSitemap,
  'sliders-h': faSlidersH,
  'sort-alpha-down': faSortAlphaDown,
  'sort-amount-down': faSortAmountDown,
  'sort-numeric-down': faSortNumericDown,
  star: faStar,
  'star-half-alt': faStarHalfAlt,
  store: faStore,
  stream: faStream,
  'sync-alt': faSyncAlt,
  table: faTable,
  tag: faTag,
  tasks: faTasks,
  th: faTh,
  'th-list': faThList,
  thumbtack: faThumbtack,
  times: faTimes,
  'times-circle': faTimesCircle,
  tools: faTools,
  'trash-alt': faTrashAlt,
  trophy: faTrophy,
  tv: faTv,
  underline: faUnderline,
  unlock: faUnlock,
  'up-down': faUpDown,
  user: faUser,
  'user-check': faUserCheck,
  'user-circle': faUserCircle,
  'user-clock': faUserClock,
  'user-cog': faUserCog,
  'user-edit': faUserEdit,
  'user-friends': faUserFriends,
  'user-lock': faUserLock,
  'user-minus': faUserMinus,
  'user-plus': faUserPlus,
  'user-shield': faUserShield,
  users: faUsers,
  'user-slash': faUserSlash,
  'wand-magic-sparkles': faWandMagicSparkles,
  wrench: faWrench
};

export type SolidIcon = keyof typeof solidIcons;
export default Object.values(solidIcons);
